module.exports = __webpack_public_path__ + "img/f41e3a5.png";